import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {getEntityStatuses as getEntitiesStatusesAPI} from '../../../services/entities'

export async function getEntityStatuses(id, params, dispatch) {
  dispatch({type: PENDING})
  try {
    const response = await getEntitiesStatusesAPI(id, params)
    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entities Statuses Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
  }
}
